<div class="card panel-flat mt-3">
  <div class="card-header panel-heading d-flex justify-content-between align-items-center">
    <span>
      <h5 class="card-title panel-title mb-0">{{selectedTitle}}</h5>
    </span>
    <span>
      <button class="btn btn-sm btn-primary" *ngIf="selectedView == 'export'" (click)="switchView('addVendor')">
        Add Vendor
      </button>
      <button class="btn btn-sm btn-primary" *ngIf="selectedView == 'addVendor'" (click)="switchView('export')">
        Import Industries
      </button>
    </span>
  </div>

  <div class="px-3">
    <section *ngIf="selectedView == 'export'">
      <div class="row mt-2">
        <div class="col-lg-12">
          <div class="box border-0 p-3 pt-1">
            <h2> Upload CSV Meta Data</h2>

            <div class="row">
              <div class="col-lg-4 mb-2">
                <select [(ngModel)]="selectedVendor" class="form-control">
                  <option value=""> Select Vendor </option>
                  <option value="{{vendor.id}}" *ngFor="let vendor of vendorList">
                    {{vendor.vendor_short_name}}
                  </option>
                </select>
              </div>

              <div class="col-lg-4 mb-2">
                <input autocomplete="off" pattern="^[^<>]*$" accept=".csv" type="file" id="selectedIndustryMetadata" class="form-control" (change)="changeListener($event.target.files)">
              </div>

              <div class="col-lg-4 mb-2">
                <button *ngIf="!uploadIndustryLoader" style="cursor: pointer;" type="button" class="btn btn-success" (click)="uploadListener()">
                  {{uploadButton}}
                  <i class="fa" [ngClass]="{'disabled': uploadButton=='Uploading','fa fa-upload':uploadButton == 'Upload','fa fa-spin fa-spinner':uploadButton == 'Uploading'}"></i>
                </button>
                <img *ngIf="uploadIndustryLoader" style="margin-top: -10px; height: 60px;" src="/assets/images/load.gif" />
              </div>
            </div>

            <div class="col-lg-12 mt-2" style="margin-left: 2%;">
              <strong style="color: red; font-size: 14px;" *ngIf="error" class="error">
                {{errorMessage}}
              </strong>

              <strong style="color: green; font-size: 14px;" *ngIf="success" class="success">
                {{successMessage}}
              </strong>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section *ngIf="selectedView == 'addVendor'" class="content">
      <div class="row mt-4">
        <div class="col-lg-12">
          <div class="form-horizontal">
            <fieldset class="content-group">
              <div class="row mb-3">
                <label class="col-lg-2 col-form-label">Vendor Complete Name*</label>
                <div class="col-lg-10">
                  <input autocomplete="off" pattern="^[^<>]*$" type="text" [(ngModel)]="vendorFullName" placeholder="Enter Vendor Complete Name. Eg. XYZ Technologies Pvt Ltd" class="form-control">
                  <div *ngIf="formErrorVendorCompleteName && VendorError">
                    <span style="margin-left: 5px; color: red; font-weight: 900;">
                      *{{formErrorVendorCompleteName}}
                    </span>
                  </div>
                </div>
              </div>

              <div class="row mb-3">
                <label class="col-lg-2 col-form-label">Vendor Short Name*</label>
                <div class="col-lg-10">
                  <input autocomplete="off" pattern="^[^<>]*$" type="text" [(ngModel)]="shortName" placeholder="Enter Vendor Short Name. Eg. XYZ" class="form-control">
                  <div *ngIf="formErrorVendorShortName && VendorError">
                    <span style="margin-left: 5px; color: red; font-weight: 900;">
                      *{{formErrorVendorShortName}}
                    </span>
                  </div>

                  <div *ngIf="vendorSuccess">
                    <div>
                      <span style="margin-left: 5px; color: green; font-weight: 900;">Vendor Token Generated:</span>
                      <span style="color: #000;">{{vendorToken}}</span>
                    </div>
                    <div>
                      <span style="margin-left: 5px; color: green; font-weight: 900;">Vendor User Id:</span>
                      <span style="color: #000;">{{user_id}}</span>
                    </div>
                    <div>
                      <span style="margin-left: 5px; color: green; font-weight: 900;">Vendor User Password:</span>
                      <span style="color: #000;">{{password}}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-lg-12">
                  <button *ngIf="!addVendorLoader" (click)="addVendor()" type="submit" class="btn btn-primary float-end">
                    <strong>Save</strong>
                  </button>
                  <span *ngIf="addVendorLoader" class="float-end">
                    <img style="height: 60px;" src="/assets/images/load.gif" />
                  </span>
                </div>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
